import { Box, SxProps } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FlexyIconButton, type FlexyIconButtonProps } from '../../atoms';
import { LazyBreadcrumb, LazyBreadcrumbsProps } from '../LazyBreadcrumb';
import { ToolbarPreviousAction } from '../../molecules/ToolbarPreviousAction/ToolbarPreviousAction';
import { VerticalDivider } from '../../atoms/VerticalDivider/VerticalDivider';

export type ToolbarAction = {
    icon: IconProp;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    label?: string;
    sx?: SxProps;
};

export type ToolbarProps = {
    path?: LazyBreadcrumbsProps['path']; // Breadcrumb path
    actions?: Array<FlexyIconButtonProps>;
    previousPath?: string;
};

export const Toolbar: React.FunctionComponent<PropsWithChildren<ToolbarProps>> = function ({
    path,
    actions,
    previousPath,
    children,
}) {
    const toolbarStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingY: '20px',
    };
    const toolbarMainContent = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        margin: '0px 15px',
    };

    const actionKeyGenerate = (index: number) => `toolbar_action_${index}`;

    return (
        <Box
            data-testid="toolbar-test-id"
            sx={toolbarStyle}
        >
            <ToolbarPreviousAction path={previousPath} />
            <Box sx={toolbarMainContent}>
                {path && (
                    <LazyBreadcrumb
                        path={path}
                        separator=" / "
                    />
                )}
                {children}
            </Box>
            <Box
                display="flex"
                justifyContent="space-between"
            >
                {actions && actions.length > 0 && (
                    <>
                        <VerticalDivider sx={{ margin: '0px 10px' }} />

                        {actions.map((action, index) => (
                            <FlexyIconButton
                                {...action}
                                key={actionKeyGenerate(index)}
                            />
                        ))}
                    </>
                )}
            </Box>
        </Box>
    );
};
